var n = Object.defineProperty, t = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var h = (r, e, i) => e in r ? n(r, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : r[e] = i, u = (r, e) => {
  for (var i in e || (e = {}))
    p.call(e, i) && h(r, i, e[i]);
  if (l)
    for (var i of l(e))
      s.call(e, i) && h(r, i, e[i]);
  return r;
}, m = (r, e) => t(r, x(e));
var y = (r, e) => {
  var i = {};
  for (var f in r)
    p.call(r, f) && e.indexOf(f) < 0 && (i[f] = r[f]);
  if (r != null && l)
    for (var f of l(r))
      e.indexOf(f) < 0 && s.call(r, f) && (i[f] = r[f]);
  return i;
};
import { jsx as g } from "react/jsx-runtime";
import { Typography as a } from "../components/Typography/Typography.es.js";
function T(f) {
  var d = f, {
    content: r,
    Component: e
  } = d, i = y(d, [
    "content",
    "Component"
  ]);
  return r ? typeof r == "string" ? /* @__PURE__ */ g(a, m(u({}, i), { children: r })) : e ? /* @__PURE__ */ g(e, m(u({}, i), { children: r })) : r : null;
}
export {
  T as renderElement
};
//# sourceMappingURL=renderElement.es.js.map
